import React from "react";
import ContentButton from "../core/ui/ContentButton";

interface PageHeroProps {
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  subheading?: React.ReactNode;
  body?: React.ReactNode;
  offer?: React.ReactNode;
  visual?: React.ReactNode;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

const PageHero: React.FC<PageHeroProps> = ({
  eyebrow,
  heading,
  subheading,
  body,
  offer,
  visual,
  primaryLabel = "Talk to Sales →",
  primaryHref = "/book-a-demo",
  secondaryLabel,
  secondaryHref,
}) => {
  const primaryIsExternal = /^https?:/.test(primaryHref);
  const copy = (
    <div>
      <div className="eyebrow">{eyebrow}</div>
      <h1>{heading}</h1>
      {subheading && <h2>{subheading}</h2>}
      {body && <div className="cs-page-hero-body">{body}</div>}
      {offer && <p className="cs-page-hero-offer">{offer}</p>}
      <div className="cs-page-hero-actions">
        <ContentButton
          href={primaryHref}
          variant="primary"
          size="lg"
          target={primaryIsExternal ? "_blank" : undefined}
          rel={primaryIsExternal ? "noopener noreferrer" : undefined}
        >
          {primaryLabel}
        </ContentButton>
        {secondaryLabel && secondaryHref && (
          <ContentButton href={secondaryHref} variant="secondary" size="lg">
            {secondaryLabel}
          </ContentButton>
        )}
      </div>
    </div>
  );
  return (
    <section className="cs-page-hero" data-testid="page-hero">
      <div className="cs-page-hero-inner">
        {visual ? (
          <div className="cs-page-hero-grid">
            {copy}
            <div className="cs-page-hero-visual">{visual}</div>
          </div>
        ) : (
          copy
        )}
      </div>
    </section>
  );
};

export default PageHero;
